<template>
  <div class="c-container" :style="computedStyle">
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { getContainerWidth } from "../config/calcContainerWidth";

export default {
  name: "Container",
  data() {
    return {
      maxWidth: 550,
    };
  },
  computed: {
    computedStyle() {
      return {
        maxWidth: `${this.maxWidth}px !important`,
      };
    },
  },
  mounted() {
    this.maxWidth = getContainerWidth();
  },
};
</script>
